import { render, staticRenderFns } from "./AssetStock-Report.vue?vue&type=template&id=23a34318&"
import script from "./AssetStock-Report.vue?vue&type=script&lang=js&"
export * from "./AssetStock-Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports